import {
  Box,
  Container,
  CssBaseline,
  Toolbar,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import Layout from "../../layout/Layout";
import { routeModules } from "../../config/routeconfig";
import Loading from "../../common/Laoding";
import { useNavigate } from "react-router-dom";
import Viewallissues from "./Viewallissues";
import Createnewissues from "./Createnewissues";

const navItems = routeModules?.viewallissuea?.sidebar;

const Issuesmodule = () => {
  const navigate = useNavigate();
  const [activeItem, setActiveItem] = useState(navItems[0]?.label || "");
  const [isLoading, setIsLoading] = useState(true);

  const renderContent = () => {
    switch (activeItem) {
      case "View all Issues":
        return <Viewallissues />;
      case "Create New Issue":
        return <Createnewissues setActiveItem={setActiveItem} />;
      default:
        return <Typography>Need Access</Typography>;
    }
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 3000);

    return () => clearTimeout(timer);
  }, []);

  // const isSessionValid = () => {
  //   const loginTime = localStorage.getItem("loginTime");
  //   if (!loginTime) return false;
  //   return Date.now() - Number(loginTime) <= 2 * 60 * 60 * 1000;
  // };

  // useEffect(() => {
  //   if (!isSessionValid()) {
  //     localStorage.clear();
  //     navigate("/");
  //   }
  // }, []);

  if (isLoading) {
    return <Loading />;
  }
  return (
    <div>
      <Box sx={{ display: "flex" }}>
        <CssBaseline />
        <Layout
          module={"viewallissuea"}
          activeItem={activeItem}
          setActiveItem={setActiveItem}
        />
        <Box
          component="main"
          sx={{
            flexGrow: 1,
            backgroundImage: "linear-gradient(to top, #ffffff, #d4dfed)",
            // p: 1,
            width: "50%",
          }}
        >
          <Toolbar />
          <Container
            maxWidth={false}
            sx={{
              flexGrow: 1,
              minHeight: "100vh",
              overflow: "hidden",
              // p: 2,
            }}
          >
            {renderContent()}
          </Container>
        </Box>
      </Box>
    </div>
  );
};

export default Issuesmodule;
